jQuery(document).ready(function ($) {

  var success_page = $("#success_page").data("url");

  var show_specials = $('[name="show_specials"]').val();

  function trackGtag() {
    if (typeof window.gtag === "function") {
      window.gtag.apply(window, arguments);
    }
  }

  function trackFbq() {
    if (typeof window.fbq === "function") {
      window.fbq.apply(window, arguments);
    }
  }

  $("#faircom-package-form-no-coverage").validate({

    errorPlacement: function errorPlacement(error, element) {

      if (element.parent(".checkbox").length)

        error.insertAfter(element.parent());

      else error.insertAfter(element);

    },

  });



  $("#faircom-package-form-columns").validate({

    errorPlacement: function errorPlacement(error, element) {

      if (element.parent(".checkbox").length)

        error.insertAfter(element.parent());

      else error.insertAfter(element);

    },

  });



  if (

    $("#faircom-package-form").length > 0 ||

    $("#faircom-package-form-no-coverage").length > 0 ||

    $("#faircom-package-form-columns").length > 0

  ) {

    $('input[name="business_telephone"]').css("opacity", 0).css("position", "absolute").css("z-index", "-1");

  }



  $("#faircom-package-form-no-coverage").on("submit", function (e) {

    e.preventDefault();

    if ($("#faircom-package-form-no-coverage").valid() !== true) {

      return;

    } else {

      $('[name="submit"]').addClass("hide");

      $(".faircape-loader-big").removeClass("hide");

      $.post(

        ajax_object.ajaxurl,

        {

          security: $(document).find("#fibre_nonce_field").attr("value"),

          data: $("#faircom-package-form-no-coverage").serialize(),

          action: "faircom_enquiry",

        },

        function (data) {

          console.log(data);

          if (data == "true") {

            if (success_page) {

              window.location.href = success_page;

            } else {

              $("#faircom-package-form-no-coverage").addClass("hide");

              $("#faircom-submit-success").removeClass("hide");

            }

          } else {

            $("#faircom-submit-error").removeClass("hide");

            $(".faircape-loader-big").addClass("hide");

            $('[name="submit"]').removeClass("hide");

          }
        }
      );
    }


    trackGtag("event", "submit", {
      event_category: "Faircom no-coverage enquiry form submission",
      event_label: "User submitted an enquiry for area without coverage",
    });


    trackFbq("track", "Submit", {
      content_name: "Fibre no-coverage form submitted",
    });
  });


  $("#faircom-package-form-columns").on("submit", function (e) {

    e.preventDefault();

    if ($("#faircom-package-form-columns").valid() !== true) {

      return;

    } else {

      $('[name="submit"]').addClass("hide");

      $(".faircape-loader-big").removeClass("hide");

      $.post(

        ajax_object.ajaxurl,

        {

          security: $(document).find("#fibre_nonce_field").attr("value"),

          data: $("#faircom-package-form-columns").serialize(),

          action: "faircom_enquiry",

        },

        function (data) {

          console.log(data);

          if (data == "true") {

            if (success_page) {

              window.location.href = success_page;

            } else {

              $("#faircom-package-form-columns").addClass("hide");

              $("#faircom-submit-success").removeClass("hide");

            }

          } else {

            $("#faircom-submit-error").removeClass("hide");

            $(".faircape-loader-big").addClass("hide");

            $('[name="submit"]').removeClass("hide");

          }

        }

      );

    }



    trackGtag("event", "submit", {
      event_category: "Faircom 3-column landing page enquiry form submission",
      event_label:
        "User submitted an enquiry using the 3-column landing page form layout",
    });



    trackGtag("event", "submit", {
      content_name: "Fibre 3-column landing page form submitted",
    });

  });



  var form = $("#faircom-package-form");

  form.validate({

    errorPlacement: function errorPlacement(error, element) {

      if (element.parent(".checkbox").length)

        error.insertAfter(element.parent().parent());

      else error.insertAfter(element);

    },

  });

  form.steps({

    headerTag: "h3",

    bodyTag: "section",

    transitionEffect: "fade",

    //enableAllSteps: true,

    //showFinishButtonAlways: true,

    labels: {

      cancel: "Cancel",

      current: "current step:",

      pagination: "Pagination",

      finish: "Submit",

      next: "Next",

      previous: "Previous",

      loading: "Loading...",

    },

    onStepChanging: function (event, currentIndex, newIndex) {

      if (currentIndex > newIndex) {

        return true;

      }

      form.validate().settings.ignore = ":disabled,:hidden";

      return form.valid();

    },

    onStepChanged: function (event, currentIndex, priorIndex) {},

    onFinishing: function (event, currentIndex) {

      form.validate().settings.ignore = ":disabled,:hidden";

      return form.valid();

    },

    onFinished: function (event, currentIndex) {

      $('[name="submit"]').addClass("hide");

      $(".faircape-loader-big").removeClass("hide");

      $(".actions").addClass("hide");

      $.post(

        ajax_object.ajaxurl,

        {

          security: $(document).find("#fibre_nonce_field").attr("value"),

          data: $("#faircom-package-form").serialize(),

          action: "faircom_enquiry",

        },

        function (data) {

          console.log(data);

          if (data == "true") {

            $(".faircape-loader-big").addClass("hide");

            if (success_page) {

              window.location.href = success_page;

            } else {

              $("#faircom-package-form").addClass("hide");

              $("#faircom-submit-success").removeClass("hide");

              if ($('[name="full_signup"]').length > 0) {

                setTimeout(function () {

                  location.reload();

                }, 5000);
              }
            }
          } else {

            $("#faircom-submit-error").removeClass("hide");

            $(".faircape-loader-big").addClass("hide");

            $('[name="submit"]').removeClass("hide");

            $(".actions").removeClass("hide");

          }
        }
      );

      trackGtag("event", "submit", {
        event_category: "Faircom enquiry form submission",
        event_label: "User submitted an enquiry",
      });

      trackFbq("track", "Submit", {
        content_name: "Fibre has-coverage form submitted",
      });
    },
  });


  function ltrim(str) {
    if (str == null) return str;
    return str.replace(/^\s+/g, "");
  }

  $(

    "#faircom-package-form input[type=text], #faircom-package-form-no-coverage input[type=text], #faircom-package-form-columns input[type=text]"

  ).on("keyup", function () {

    var string = $(this).val();

    trim = ltrim(string);

    $(this).val(trim);

  });



  $('#faircom-package-form-columns input[name="telephone_number"], #faircom-package-form input[name="telephone_number"], #faircom-package-form-no-coverage input[name="telephone_number"]').mask("(000) 000 0000");

  $('#faircom-package-form-columns input[name="cellphone_number"], #faircom-package-form input[name="cellphone_number"], #faircom-package-form-no-coverage input[name="cellphone_number"]').mask("(000) 000 0000");



  var couponType;

  var couponDiscountType;

  var couponDiscountPercentage;

  var couponDiscountValue;

  var couponValid;



  function apply_discount(price) {

    //var price = parseInt($(this));

    if (couponValid == 1 && couponType == "discount") {

      if (couponDiscountType == "percentage") {

        price = price - (price / 100) * couponDiscountPercentage;

      } else {

        price = price - couponDiscountValue;

      }

    }

    $("#discounted_price").val(price);

    return price;

  }



  $(document).on("change", 'input[name="need_fibre_router"]', function () {

    console.log("triggered");



    var router_requirements = $('select[name="package"]:not(:disabled)')

      .find("option:selected")

      .data("router");



    //console.log(router_requirements);



    if (router_requirements == "high") {

      $(".high-speed-router-options").removeClass("hide").addClass("active");

      $(".low-speed-router-options").addClass("hide").removeClass("active");

      $('.high-speed-router-options [name="router_option"]').prop("disabled",false);

      $('.low-speed-router-options [name="router_option"]').prop("disabled",true);

    } else {

      $(".low-speed-router-options").removeClass("hide").addClass("active");

      $(".high-speed-router-options").addClass("hide").removeClass("active");

      $('.high-speed-router-options [name="router_option"]').prop("disabled",true);

      $('.low-speed-router-options [name="router_option"]').prop("disabled",false);

    }



    var router_option_price = $('.active select[name="router_option"]').find("option:selected").data("price");

    var router_option_duration = $('.active select[name="router_option"]').find("option:selected").data("duration");

    var package_price = $('select[name="package"]:not(:disabled)').find("option:selected").data("price");

    var need_fibre_router = $('input[name="need_fibre_router"]');

    var monthly_price;



    var addon_option_price = $('select[name="addon_packages"]').find("option:selected").data("price");

    var addon_option_duration = $('select[name="addon_packages"]').find("option:selected").data("term");

    var addon_price = 0;

    if (addon_option_duration == "monthly") {

      addon_price = addon_option_price;

    }



    var package_extra           = $('select[name="package"]:not(:disabled)').find("option:selected").data("extra");

    var package_extra_accept    = `<div class="fibre-form-notice-accept">

                                    <input type="checkbox"class="required" name="promotion_terms_accepted" value="Promotion Terms Accepted">

                                    <label>I understand and accept the terms of this promotion.</label>

                                  </div>`;



    if ($(this).prop("checked") && $(this).val() == "yes") {

      $(".router-options").removeClass("hide");

      $("#no_router_message").addClass("hide");
      $('#no_router_mandate').addClass('hide');

      $('.active [name="router_option"]').prop("disabled", false);

      if ((router_option_duration !== 0) && (need_fibre_router.prop("unchecked"))) {

        monthly_price = parseInt(package_price) + parseInt(router_option_price) + parseInt(addon_price);

        monthly_price = apply_discount(monthly_price);



        $("#what-you-pay")

        .html(

            "<div class='what-you-pay-container'><p><strong>What you will pay monthly:</strong> <br />" +

            "Router Price: Free-to-use</p>" +

            "<h2>R" + parseFloat(monthly_price).toFixed(2) + "</h2></div>" + 

            "<div class='fibre-form-notice'><p>"+ package_extra +"</p>" + package_extra_accept +"</div>")

            .attr("data-price", monthly_price);

      } else if ((router_option_duration !== 0) && (need_fibre_router.prop("checked"))) {

        monthly_price = parseInt(package_price) + parseInt(router_option_price) + parseInt(addon_price);

        monthly_price = apply_discount(monthly_price);

        $("#what-you-pay")

          .html(

            "<div class='what-you-pay-container'><p><strong>What you will pay monthly:</strong><br />" +

            "Package Price: R" + parseFloat(package_price).toFixed(2) + "<br />"  +

            "Router Price: R" + parseFloat(router_option_price).toFixed(2) + " (Per Month)</p>" +

            "<h2>R" + parseFloat(monthly_price).toFixed(2) + "</h2></div>" + 

            "<div class='fibre-form-notice'><p>"+ package_extra +"</p>" + package_extra_accept +"</div>")

            .attr("data-price", monthly_price);

      } else {

        monthly_price = parseInt(package_price) + parseInt(addon_price);

        monthly_price = apply_discount(monthly_price);

        $("#what-you-pay")

          .html(

            "<div class='what-you-pay-container'><p><strong>What you will pay monthly:</strong><br />" +

            "Package Price: R" + parseFloat(package_price).toFixed(2) + "<br />"  +

            "Router Price: R" + parseFloat(router_option_price).toFixed(2) + " (Per Month)</p>" +

            "<h2>R" + parseFloat(monthly_price).toFixed(2) + "</h2></div>" + 

            "<div class='fibre-form-notice'><p>"+ package_extra +"</p>" + package_extra_accept +"</div>")

            .attr("data-price", monthly_price);

      }

    } else if ($(this).prop("checked") && $(this).val() == "no") {

      $("#no_router_message").removeClass("hide");
      $('#no_router_mandate').removeClass('hide');

      $(".router-options").addClass("hide");

      $('.active [name="router_option"]').prop("disabled", true);

      monthly_price = parseInt(package_price) + parseInt(addon_price);

      monthly_price = apply_discount(monthly_price);

      $("#what-you-pay")

        .html(

          "<div class='what-you-pay-container'><p><strong>What you will pay monthly:</strong><br />" +

          "Package Price: R" + parseFloat(package_price).toFixed(2) + "<br />"  +

          "<h2>R" + parseFloat(monthly_price).toFixed(2) + "</h2></div>" + 

          "<div class='fibre-form-notice'><p>"+ package_extra +"</p>" + package_extra_accept +"</div>")

          .attr("data-price", monthly_price);

    }

  });



  $(document).on("change", 'select[name="router_option"]', function () {

    var router_option_price = $(this).find("option:selected").data("price");

    var router_option_duration = $(this).find("option:selected").data("duration");

    var package_price = $('select[name="package"]:not(:disabled)').find("option:selected").data("price");

    var monthly_price;



    var addon_option_price = $('select[name="addon_packages"]').find("option:selected").data("price");

    var addon_option_duration = $('select[name="addon_packages"]').find("option:selected").data("term");

    var addon_price = 0;

    if (addon_option_duration == "monthly") {

      addon_price = addon_option_price;

    }



    var package_extra           = $('select[name="package"]:not(:disabled)').find("option:selected").data("extra");

    var package_extra_accept    = `<div class="fibre-form-notice-accept">

                                    <input type="checkbox"class="required" name="promotion_terms_accepted" value="Promotion Terms Accepted">

                                    <label>I understand and accept the terms of this promotion.</label>

                                  </div>`;



    if (router_option_duration !== 0) {

      monthly_price = parseInt(package_price) + parseInt(router_option_price) + parseInt(addon_price);

      monthly_price = apply_discount(monthly_price);

      $("#what-you-pay")

      .html(

          "<div class='what-you-pay-container'><p><strong>What you will pay monthly:</strong><br />" +

          "Package Price: R" + parseFloat(package_price).toFixed(2) + "<br />"  +

          "Router Price: R" + parseFloat(router_option_price).toFixed(2) + " (Per Month)</p>" +

          "<h2>R" + parseFloat(monthly_price).toFixed(2) + "</h2></div>" + 

          "<div class='fibre-form-notice'><p>"+ package_extra +"</p>" + package_extra_accept +"</div>")

          .attr("data-price", monthly_price);

    } else {

      monthly_price = parseInt(package_price) + parseInt(addon_price);

      monthly_price = apply_discount(monthly_price);

      $("#what-you-pay")

        .html(

          "<div class='what-you-pay-container'><p><strong>What you will pay:</strong>" + "<br />"  +

          "Package Price:" + " R" + parseFloat(package_price).toFixed(2) + "<br />"  +

          "Router Price: " + " R" + parseFloat(router_option_price).toFixed(2) + " (Once off)</p>" +

          "<h2>R" + parseFloat(monthly_price).toFixed(2) +"pm </h2></div>" + 

          "<div class='fibre-form-notice'><p>"+ package_extra +"</p>" + package_extra_accept +"</div>")

          .attr("data-price", monthly_price);

    }

  });



  $(document).on("change", 'select[name="addon_packages"]', function () {

    var addon_option_price = $(this).find("option:selected").data("price");

    var addon_option_duration = $(this).find("option:selected").data("term");

    var addon_price = 0;

    if (addon_option_duration == "monthly") {

      addon_price = addon_option_price;

    }



    var package_price = $('select[name="package"]:not(:disabled)')

      .find("option:selected").data("price");

    var monthly_price;



    var router_option_price = $('.active select[name="router_option"]').find("option:selected").data("price");

    var router_option_duration = $('.active select[name="router_option"]').find("option:selected").data("duration");

    var router_requirements = $('select[name="package"]:not(:disabled)').find("option:selected").data("router");



    var package_extra           = $('select[name="package"]:not(:disabled)').find("option:selected").data("extra");

    var package_extra_accept    = `<div class="fibre-form-notice-accept">

                                    <input type="checkbox"class="required" name="promotion_terms_accepted" value="Promotion Terms Accepted">

                                    <label>I understand and accept the terms of this promotion.</label>

                                  </div>`;



    if (router_requirements == "high") {

      $(".high-speed-router-options").removeClass("hide").addClass("active");

      $(".low-speed-router-options").addClass("hide").removeClass("active");

    } else {

      $(".low-speed-router-options").removeClass("hide").addClass("active");

      $(".high-speed-router-options").addClass("hide").removeClass("active");

    }

    $('.active [name="router_option"]').prop("disabled", false);



    if (router_option_duration !== 0) {

      monthly_price =

        parseInt(package_price) +

        parseInt(router_option_price) +

        parseInt(addon_price);

      monthly_price = apply_discount(monthly_price);

      $("#what-you-pay")

        .html(

          "<div class='what-you-pay-container'><p><strong>What you will pay monthly:</strong></p><h2>R" +

            parseFloat(monthly_price).toFixed(2) +

            "</h2></div>" + 

            "<div class='fibre-form-notice'><p>"+ package_extra +"</p>" + package_extra_accept +"</div>")

            .attr("data-price", monthly_price);

    } else {

      monthly_price = parseInt(package_price) + parseInt(addon_price);

      monthly_price = apply_discount(monthly_price);

      $("#what-you-pay")

        .html(

          "<div class='what-you-pay-container'><p><strong>What you will pay monthly:</strong></p><h2>R" +

            parseFloat(monthly_price).toFixed(2) +

            "</h2></div>" + 

            "<div class='fibre-form-notice'><p>"+ package_extra +"</p>" + package_extra_accept +"</div>")

            .attr("data-price", monthly_price);

    }

  });



  var priceOnLoad = $('select[name="package"] option:selected').data("price");



  var package_extra           = $('select[name="package"]:not(:disabled)').find("option:selected").data("extra");

  var package_extra_accept    = `<div class="fibre-form-notice-accept">

                                    <input type="checkbox"class="required" name="promotion_terms_accepted" value="Promotion Terms Accepted">

                                    <label>I understand and accept the terms of this promotion.</label>

                                  </div>`;



  $("#what-you-pay")

    .html(

      "<div class='what-you-pay-container'><p><strong>What you will pay monthly:</strong></p><h2>R" +

        parseFloat(priceOnLoad).toFixed(2) +

        "</h2></div>" + 

        "<div class='fibre-form-notice'><p>"+ package_extra +"</p>" + package_extra_accept +"</div>")

        .attr("data-price", priceOnLoad);



  $(document).on("change", 'select[name="package"]', function () {

    var addon_option_price = $('select[name="addon_packages"]').find("option:selected").data("price");

    var addon_option_duration = $('select[name="addon_packages"]').find("option:selected").data("term");

    var addon_price = 0;

    if (addon_option_duration == "monthly") {

      addon_price = addon_option_price;

    }



    var router_requirements = $(this).find("option:selected").data("router");

    if (router_requirements == "high") {

      $(".high-speed-router-options").removeClass("hide").addClass("active");

      $(".low-speed-router-options").addClass("hide").removeClass("active");

    } else {

      $(".low-speed-router-options").removeClass("hide").addClass("active");

      $(".high-speed-router-options").addClass("hide").removeClass("active");

    }

    $('.active [name="router_option"]').prop("disabled", false);



    var router_option_price = $('.active select[name="router_option"]').find("option:selected").data("price");

    var router_option_duration = $('.active select[name="router_option"]').find("option:selected").data("duration");

    var package_price = $(this).find("option:selected").data("price");

    var need_fibre_router = $('input[name="need_fibre_router"]');



    var monthly_price;



    var package_extra           = $('select[name="package"]:not(:disabled)').find("option:selected").data("extra");

    var package_extra_accept    = `<div class="fibre-form-notice-accept">

                                    <input type="checkbox"class="required" name="promotion_terms_accepted" value="Promotion Terms Accepted">

                                    <label>I understand and accept the terms of this promotion.</label>

                                  </div>`;



    if ((router_option_duration !== 0) && (need_fibre_router.prop("unchecked"))) {

      monthly_price = parseInt(package_price) + parseInt(router_option_price) + parseInt(addon_price);

      monthly_price = apply_discount(monthly_price);

      $("#what-you-pay")

        .html(

          "<div class='what-you-pay-container'><p><strong>What you will pay monthly:</strong> <br />" +

          "Package Price: R" + parseFloat(package_price).toFixed(2) + "<br />"  +

          "<h2>R" + parseFloat(monthly_price).toFixed(2) + "</h2></div>" + 

          "<div class='fibre-form-notice'><p>"+ package_extra +"</p>" + package_extra_accept +"</div>")

          .attr("data-price", monthly_price);

    } else if ((router_option_duration !== 0) && (need_fibre_router.prop("checked"))) {

        monthly_price = parseInt(package_price) + parseInt(router_option_price) + parseInt(addon_price);

        monthly_price = apply_discount(monthly_price);

        $("#what-you-pay")

          .html(

            "<div class='what-you-pay-container'><p><strong>What you will pay monthly:</strong><br />" +

            "Package Price: R" + parseFloat(package_price).toFixed(2) + "<br />"  +

            "Router Price: R" + parseFloat(router_option_price).toFixed(2) + " (Per Month)</p>" +

            "<h2>R" + parseFloat(monthly_price).toFixed(2) + "</h2></div>" + 

            "<div class='fibre-form-notice'><p>"+ package_extra +"</p>" + package_extra_accept +"</div>")

            .attr("data-price", monthly_price);

    } else {

      monthly_price = parseInt(package_price) + parseInt(addon_price);

      monthly_price = apply_discount(monthly_price);

      $("#what-you-pay")

        .html(

          "<div class='what-you-pay-container'><p><strong>What you will pay monthly:</strong> <br />" +

          "Package Price: R" + parseFloat(package_price).toFixed(2) + "<br />"  +

          "Router Price: R" + parseFloat(router_option_price).toFixed(2) + " (Per Month)</p>" +

          "<h2>R" + parseFloat(monthly_price).toFixed(2) + "</h2></div>" + 

          "<div class='fibre-form-notice'><p>"+ package_extra +"</p>" + package_extra_accept +"</div>")

          .attr("data-price", monthly_price);

    }

  });



  $('.commercial_packages [name="package"]').prop("disabled", true).addClass("disabled");

  $(".commercial_packages").addClass("hide");



  function initLoadPackages() {

    var $this = $('select[name="home_or_business"]');

    showSpecials(show_specials);

    if ($($this).val() == "home") {

      $(".home_packages").removeClass("hide");

      $(".commercial_packages").addClass("hide");



      $(".commercial-router-text").addClass("hide");

      $(".router-section").removeClass("hide");

    } else if ($($this).val() == "business") {

      $(".home_packages").addClass("hide");

      $(".commercial_packages").removeClass("hide");



      $(".router-section").addClass("hide");

      $(".commercial-router-text").removeClass("hide");

    }



    var addon_option_price = $('select[name="addon_packages"]').find("option:selected").data("price");

    var addon_option_duration = $('select[name="addon_packages"]').find("option:selected").data("term");

    var addon_price = 0;

    if (addon_option_duration == "monthly") {

      addon_price = addon_option_price;

    }



    var router_option_price = $('.active select[name="router_option"]').find("option:selected").data("price");

    var router_option_duration = $('.active select[name="router_option"]').find("option:selected").data("duration");

    var package_price = $('select[name="package"]:not(:disabled)').find("option:selected").data("price");

    var monthly_price;



    var package_extra           = $('select[name="package"]:not(:disabled)').find("option:selected").data("extra");

    var package_extra_accept    = `<div class="fibre-form-notice-accept">

                                    <input type="checkbox"class="required" name="promotion_terms_accepted" value="Promotion Terms Accepted">

                                    <label>I understand and accept the terms of this promotion.</label>

                                  </div>`;



    if ($($this).val() == "business") {

      $("#what-you-pay")

        .html(

          "<div class='what-you-pay-container'><p><strong>What you will pay monthly:</strong></p><h2>R" +

            parseFloat(package_price).toFixed(2) +

            "</h2></div>" + 

            "<div class='fibre-form-notice'><p>"+ package_extra +"</p>" + package_extra_accept +"</div>")

            .attr("data-price", package_price);

    } else {

      if ($(".router-options").hasClass("hide")) {

        package_price = apply_discount(package_price);

        $("#what-you-pay").html

        ("<div class='what-you-pay-container'><p><strong>What you will pay monthly:</strong></p><h2>R" + 

          parseFloat(package_price).toFixed(2) + "</h2></div>" + 

          "<div class='fibre-form-notice'><p>"+ package_extra +"</p>" + package_extra_accept +"</div>")

          .attr("data-price", package_price);

      } else {

        if (router_option_duration !== 0) {

          monthly_price =

            parseInt(package_price) +

            parseInt(router_option_price) +

            parseInt(addon_option_price);

          monthly_price = apply_discount(monthly_price);

          $("#what-you-pay")

            .html(

              "<div class='what-you-pay-container'><p><strong>What you will pay monthly:</strong></p><h2>R" +

                parseFloat(monthly_price).toFixed(2) +

                "</h2></div>" + 

                "<div class='fibre-form-notice'><p>"+ package_extra +"</p>" + package_extra_accept +"</div>")

                .attr("data-price", monthly_price);

        } else {

          monthly_price =

            parseInt(package_price) + parseInt(addon_option_price);

          monthly_price = apply_discount(monthly_price);

          $("#what-you-pay")

            .html(

              "<div class='what-you-pay-container'><p><strong>What you will pay monthly:</strong></p><h2>R" +

                parseFloat(monthly_price).toFixed(2) +

                "</h2></div>" + 

                "<div class='fibre-form-notice'><p>"+ package_extra +"</p>" + package_extra_accept +"</div>")

                .attr("data-price", monthly_price);

        }

      }

    }

  }

  initLoadPackages();



  $(document).on("change", 'select[name="home_or_business"]', function () {

    initLoadPackages();

  });



  $(document).on("change", 'select[name="referral"]', function () {

    if ($(this).val() == "Other" || $(this).val() == "other") {

      $("#referral_other").removeClass("hide");

      $('[name="referral_other"]')

        .prop("disabled", false)

        .removeClass("disabled");

      $("#manager_name").addClass("hide");

      $('[name="manager_name"]').prop("disabled", true).addClass("disabled");

      $('[name="referral_other"]').rules("add", {

        required: true,

      });

    } else if (

      $(this).val() == "Building manager" ||

      $(this).val() == "building manager" ||

      $(this).val() == "Building Manager" ||

      $(this).val() == "Recommended by Building Manager"

    ) {

      $("#referral_other").addClass("hide");

      $('[name="referral_other"]').rules("remove");

      $('[name="referral_other"]').prop("disabled", true).addClass("disabled");

      $("#manager_name").removeClass("hide");

      $('[name="manager_name"]').prop("disabled", false).removeClass("disabled");

    } else {

      $("#referral_other").addClass("hide");

      $("#manager_name").addClass("hide");

      $('[name="referral_other"]').rules("remove");

      $('[name="referral_other"]').prop("disabled", true).addClass("disabled");

      $('[name="manager_name"]').prop("disabled", true).addClass("disabled");

    }

  });



  $("select#building_selector").on("change", function () {

    if ($(this).val() !== "") {

      window.location = $(this).val();

    }

  });



  function showSpecials(status) {

    $(".package-option").removeClass("active-packages").addClass("hide");

    if (status == 1) {

      if ($('[name="home_or_business"]').val() == "home") {

        if ($('#specials_packages [name="package"]').length == 0) {

          $("#standard_packages").removeClass("hide").addClass("active-packages");

        } else {

          $("#specials_packages").removeClass("hide").addClass("active-packages");

        }

      }

      if ($('[name="home_or_business"]').val() == "business") {

        if ($('#specials_packages_commercial [name="package"]').length == 0) {

          $("#standard_packages_commercial").removeClass("hide").addClass("active-packages");

        } else {

          $("#specials_packages_commercial").removeClass("hide").addClass("active-packages");

        }

      }

    }

    //Status = 0

    else {

      if ($('[name="home_or_business"]').val() == "home") {

        $("#standard_packages").removeClass("hide").addClass("active-packages");

      }

      if ($('[name="home_or_business"]').val() == "business") {

        $("#standard_packages_commercial").removeClass("hide").addClass("active-packages");

      }



      if ($('#standard_packages [name="package"]').length == 0) {

        $('#home_or_business option[value="home"]').prop("disabled", true);

      } else {

        $('#home_or_business option[value="home"]').prop("disabled", false);

      }

      if ($('#standard_packages_commercial [name="package"]').length == 0) {

        $('#home_or_business option[value="business"]').prop("disabled", true);

      } else {

        $('#home_or_business option[value="business"]').prop("disabled", false);

      }

    }

    //general

    $('[name="package"]').prop("disabled", true);

    $('.active-packages [name="package"]').prop("disabled", false);

  }

  showSpecials(show_specials);



  $(

    "#survey_questions input, #survey_questions select, #survey_questions textarea"

  ).prop("disabled", true);

  $(document).on("change", '[name="survey_opt_in"]', function () {

    var condition = $('[name="survey_specials_condition"]').val();

    if ($(this).val() == 1) {

      $("#survey_questions").removeClass("hide");

      $(

        "#survey_questions input, #survey_questions select, #survey_questions textarea"

      ).prop("disabled", false);

      if (condition == 1) {

        show_specials = 1;

      }

    } else {

      $("#survey_questions").addClass("hide");

      $(

        "#survey_questions input, #survey_questions select, #survey_questions textarea"

      ).prop("disabled", true);

      if (condition == 1) {

        show_specials = $('[name="show_specials"]').val();

      }

    }

    showSpecials(show_specials);

  });



  $('[name="full_signup"]').on("change", function () {

    if ($(this).val() == 1) {

      if ($('[name="survey_opt_in"]').length > 0) {

        form.steps("insert", Number(1), {

          title: $("#survey_container h3").text(),

          content: $("#survey_container section").html(),

        });

        form.steps("insert", Number(2), {

          title: $("#package_details_container h3").text(),

          content: $("#package_details_container section").html(),

        });

        form.steps("insert", Number(4), {

          title: $("#billing_details_container h3").text(),

          content: $("#billing_details_container section").html(),

        });

        form.steps("insert", Number(5), {

          title: $("#payment_details_container h3").text(),

          content: $("#payment_details_container section").html(),

        });

      } else {

        form.steps("insert", Number(2), {

          title: $("#package_details_container h3").text(),

          content: $("#package_details_container section").html(),

        });

        form.steps("insert", Number(3), {

          title: $("#billing_details_container h3").text(),

          content: $("#billing_details_container section").html(),

        });

        form.steps("insert", Number(4), {

          title: $("#payment_details_container h3").text(),

          content: $("#payment_details_container section").html(),

        });

      }



      $("#id_container").removeClass("hide");

      $('[name="id_number"]').prop("disabled", false).removeClass("disabled");

    } else {

      if ($('[name="survey_opt_in"]').length > 0) {

        form.steps("remove", Number(5));

        form.steps("remove", Number(4));

        form.steps("remove", Number(3));

        form.steps("remove", Number(2));

      } else {

        form.steps("remove", Number(4));

        form.steps("remove", Number(3));

        form.steps("remove", Number(2));

      }



      $("#id_container").addClass("hide");

      $('[name="id_number"]').prop("disabled", true).addClass("disabled");

    }

  });



  $(document).on("change", ".other-option-toggle", function () {

    if ($(this).prop("checked")) {

      $(this).parents(".option-group").find(".other-conditional-field").removeClass("hide");

    } else {

      $(this).closest(".option-group").find(".other-conditional-field").addClass("hide");

    }

  });



  $(document).on("click", ".hs-button", function () {
    trackFbq("track", "Submit", {
      content_name: "Contact form submitted",
    });
  });



  $("#coupon_submit").on("click", function (e) {

    e.preventDefault();

    $.post(

      ajax_object.ajaxurl,

      {

        security: $(document).find("#fibre_nonce_field").attr("value"),

        data: $(document).find("#faircom-package-form").serialize(),

        action: "coupon_check",

      },

      function (data) {

        console.log(data);

        var response = jQuery.parseJSON(data);

        $("#coupon_message").text(response.message).removeClass("hide");



        if (parseInt(response.valid) == 1) {

          $("#coupon_message").addClass("success").removeClass("error");



          couponValid = parseInt(response.valid);

          couponType = response.type;

          couponDiscountType = response.discount_type;

          couponDiscountPercentage = parseInt(response.discount_percentage);

          couponDiscountValue = parseInt(response.discount_value);



          if (couponValid == 1) {

            $("#coupon_type").val(couponType);

            if (couponType == "discount") {

              var monthly_price = parseInt($("#what-you-pay").data("price"));

              monthly_price = apply_discount(monthly_price);

              $("#what-you-pay")

                .html(

                  "<p><strong>What you will pay monthly:</strong></p><h2>R" +

                    parseFloat(monthly_price).toFixed(2) +

                    "</h2>"

                ).attr("data-price", monthly_price);

              $("#coupon_discount_type").val(couponDiscountType);

              if (couponDiscountType == "percentage") {

                $("#coupon_discount_percentage").val(couponDiscountPercentage);

              }

              if (couponDiscountType) {

                $("#coupon_discount_value").val(couponDiscountValue);

              }

            }

          }

        } else {

          $("#coupon_message").addClass("error").removeClass("success");

        }

      }

    );

  });

});

